/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";
import { stringify } from "qs";
import { token, channel_code, device_id, source, appversion, user_id, love_stock_pro_is_show_all,u_id, origin_user_id,bundle_name } from "@/utils/urlQuery";
import { objectIsEmpty } from '../utils/index';

import store from '@/store';
// 环境的切换
var base = '.aigupiao.com/', baseURL = "";
if (process.env.NODE_PM === "prod") {
    baseURL = "https://app"+base;
} else if (process.env.NODE_PM === "dev") {
    baseURL = "https://appdev"+base;
} else if (process.env.NODE_PM === "beta") {
    baseURL = "https://appbeta"+base;
} else {
    baseURL = "https://appdev"+base;
    //baseURL = "https://appdev"+base;
    // baseURL = "";
}

console.log('store',store)


const axiosApp = axios.create({
    baseURL,
    timeout: 20 * 1000, // 请求超时时间
    withCredentials: true, // Check cross-site Access-Control
})

// 请求拦截器 
axiosApp.interceptors.request.use(
    (config) => {
        console.info(config,'config')
        if (config.method === "post") {
            // 修改 Content-Type
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
            // 将对象参数转换为序列化的 URL 形式（key=val&key=val） 
            config.data = stringify(config.data);
        }
        let localToken = localStorage['Authorization'];
        config.headers['Authorization'] = token || (store&&store.state&&store.state.user&&store.state.user.user_app_token ? 'Bearer '+store.state.user.user_app_token : '') || (localToken? "Bearer " + localToken: localToken);
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);

// 添加响应拦截器
axiosApp.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    let config = response.config;
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

//id=46
// l_id=47
// time=1716193786

// appversion=11.5.0
// love_stock_pro_is_show_all=1
// source=ios
// u_id=44324
// user_id=44324

// origin_user_id=0 // 审核
// bundle_name=love_stock_pro

// igptoken=ZmU4MDo6YzlhYToxZDNkOjY1Zjk6ZTM5N18xNzE2MTk0Mzg2XzE3MTYxOTM3ODZfZGRjZWU5OTQ1MTcwMDZmZjM2ZmJjZTY1MTFlNGM3YTc
// lgStatus=531856593dd2bd769082e276ab38b6d4
// mds=531856593dd2bd769082e276ab38b6d4
// sign=f07a6622d5ef4d371160cd3b6330e28c
// vtoken=a3572ff460107fe0e3d570950b7ee5d8
export const get = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        let ParmamsObj = {
        }
        let queryObj = {
            // channel_code,
            // device_id,
            love_stock_pro_is_show_all,
            source,
            appversion:'11.8.0',
            user_id,
            u_id,
            origin_user_id,
            bundle_name
        }
        Object.keys(queryObj).map((item, i) => {
            if (queryObj[item]) {
                ParmamsObj[item] = queryObj[item]
            }
        })
        axiosApp
            .get(url, {
                params: {
                    ...ParmamsObj,
                    ...params,
                }
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
};
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        let ParmamsObj = {
        }
        let queryObj = {
            // channel_code,
            // device_id,
            love_stock_pro_is_show_all,
            source,
            appversion:'11.8.0',
            user_id,
            u_id,
            origin_user_id,
            bundle_name
        }
        Object.keys(queryObj).map((item, i) => {
            if (queryObj[item]) {
                ParmamsObj[item] = queryObj[item]
            }
        })
        axiosApp
            .post(url, {
                Authorization: token || (store&&store.state&&store.state.user&&store.state.user.user_app_token ? 'Bearer '+store.state.user.user_app_token : ''),
                ...ParmamsObj,
                ...params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
};


/** 
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get2 = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        axiosApp.get(url, {
            params: { 'Agp-Super-Project': '1', ...params }
        }).then(res => {
            // console.log(res,"axiosApp data")
            var data = {}
            data.data = res.data.data
            if (objectIsEmpty(res.data.share)) {
                // console(1111,res.data)
                resolve(res.data);
            } else if (~url.indexOf('/H5ReactUserCenter/add_stock') || ~url.indexOf('/H5ReactUserCenter/del_stock') ||
                ~url.indexOf('/calf/')) {
                resolve(res.data);
            } else {
                // console.log(22222,res.data.data)
                resolve(res.data.data);
            }
        }).catch(err => {
            reject(err.data)
        })
    });
}